var angular = require('angular');

export default function (app_name) {
    var initInjector = angular.injector(["ng"]);
    var $http = initInjector.get("$http");
    $http.get("/_bootstrap")
        .then(function (response) {
            angular.module('constants')
                .constant("APP_CONFIG", response.data.settings);
            angular.bootstrap(document, [app_name]);
        }, function () {
            angular.module('constants')
                .constant("APP_CONFIG", {});
            angular.bootstrap(document, [app_name]);
        });
};
